export default __webpack_public_path__ + "static/media/VolvoNovum-Regular.6f1e8482.eot";